import React, { useState } from "react";
import axios from "axios";
import "../../styles/fieldform.css";
import Cookies from "js-cookie";
import api from "../../api.js";

const user_id = Cookies.get("user_id"); // Read user id from cookies
const token = Cookies.get("access_token");

const FieldForm = ({ show, handleClose }) => {
    const [formData, setFormData] = useState({
        title: "",
        thumbnail: null,
        description: "",
        author:"",
        users_with_access:""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, thumbnail: e.target.files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        formDataToSend.append("title", formData.title);
        formDataToSend.append("thumbnail", formData.thumbnail);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("author",user_id);
        formDataToSend.append("users_with_access",user_id);

        try {
            await api.post("/field/myfields/", formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });
/*            alert("Field created successfully!");*/
            window.location.reload(); // Reload page to show new field
        } catch (error) {
            console.error("Error creating field:", error);
        }
    };

    return (
        <div className={`modal ${show ? "d-block" : "d-none"}`} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" style={{justifyItems:"left",fontSize:"10px"}}  onClick={handleClose}></button>
                        {/* <h5 className="modal-title" style={{ fontFamily: "'Vazirmatn', sans-serif", fontSize: "14px" }}>ایجاد حوزه جدید</h5>
                         */}
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label" >عنوان</label>
                                <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label" >تصویر</label>
                                <input type="file" className="form-control" name="thumbnail" onChange={handleFileChange} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">توضیحات</label>
                                <textarea className="form-control" name="description" value={formData.description} onChange={handleChange} required />
                            </div>
                            <button type="submit" className="btn-submit btn-primary">ثبت</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FieldForm;
